<template>
    <div>

        <!-- nav -->
        <header v-if="feedType == null || feedType === 'user'" class="mb-2 mt-md-0 bg-white shadow-sm rounded" :class="{ 'mt-n4': feedType == null, 'mt-n2': feedType == 'user' }">
            <div v-if="feedType == null" class="nav-scroller border-bottom w-100 ">
                <div class="nav nav-tabs">
                    <a @click="changeTab('for_you')" href="#" class="nav-link" :class="{ 'active': tab === 'for_you' }">
                        <i class="fas fa-sparkles"></i>
                        <span class="menu-text">For You</span>
                    </a>
                    <a @click="changeTab('following')" href="#" class="nav-link" :class="{ 'active': tab === 'following' }">
                        <i class="fas fa-user-friends"></i>
                        <span class="menu-text">Following</span>
                    </a>
                </div>
            </div>
            <div v-if="tab === 'following' || feedType === 'user'" class="w-100 p-2">
                <div class="d-flex">
                    <FilterChip class="mr-2" name="Filter" :value="privacyFilter" :options="privacyFilterOptions" @selected="onPrivacyFilterSelected($event)"/>
                </div>
            </div>
        </header>

        <!-- posts -->
        <div class="row">

            <div v-if="featuredPost && !isFeaturedPostDeleted" class="col-12">
                <Post :post="featuredPost" :viewer="user"
                      :show-pinned-post-badge="feedType === 'user'"
                      @deleted="onFeaturedPostDeleted"/>
            </div>

            <div v-if="featuredPost && !isFeaturedPostDeleted && posts.length > 0" class="col-12">
                <h6 class="mb-3 text-muted mx-3 mx-md-0">
                    <span class="fa fa-newspaper"></span> My Latest Posts
                </h6>
            </div>

            <div v-for="post in posts" :key="post.id" class="col-12">
                <Post :post="post" :viewer="user"
                      :show-follow-button="feedType == null && tab === 'for_you'"
                      :show-hide-user-button="feedType == null && tab === 'for_you'"
                      :show-hide-post-button="feedType == null && tab === 'for_you'"
                      :show-pinned-post-badge="feedType === 'user'"
                      @user-followed="onUserFollowed($event)"
                      @user-unfollowed="onUserUnfollowed($event)"
                      @user-hidden="onUserHidden($event)"
                      @post-hidden="onPostHidden($event)"
                      @deleted="onPostDeleted(post)"/>
            </div>

        </div>

        <!-- empty state -->
        <div v-if="posts.length === 0 && !isLoading" class="d-flex">
            <div class="mx-auto my-auto p-4">
                <div class="empty-state">
                    <div class="empty-state-container">
                        <div class="state-figure">
                            <img class="img-fluid" src="/assets/images/undraw_empty_xct9.svg" alt="" style="max-width:150px">
                        </div>
                        <h3 class="state-header mb-0">There's no posts to see</h3>
                        <p class="state-description text-muted">Follow Exclusv Creators to see their Latest Posts</p>
                        <div class="state-action">
                            <a :href="route('dashboard.feed.index')" type="button" class="btn btn-primary rounded-pill">
                                <span class="fa fa-search"></span> Discover Exclusv Creators
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- loading spinner -->
        <div v-if="isLoading" class="d-flex">
            <div class="mx-auto my-auto p-4">
                <div class="text-center mb-2">
                    <i class="fad fa-2x fa-spinner-third fa-spin"/>
                </div>
            </div>
        </div>

        <!-- load more -->
        <div id="load-more" v-if="hasMore" class="d-flex mx-2">
            <button v-if="!isLoading" @click="loadMore" type="button" class="btn btn-secondary w-100">
                <i class="fa fa-chevron-circle-down"></i> Load More
            </button>
        </div>

    </div>
</template>

<script>
import Post from "./Post.vue";
import FilterChip from "../Feed/FilterChip.vue";

export default {
    name: 'Main',
    components: {
        FilterChip,
        Post,
    },
    props: {
        "feedType": {
            default: null,
            required: false,
        },
        "userId": {
            default: null,
            required: false,
        },
        "hashtag": {
            default: null,
            required: false,
        },
        "excludedPostIds": {
            default: null,
            required: false,
        },
        "featuredPostId": {
            default: null,
            required: false,
        },
    },
    data: function() {
        return {

            tab: 'for_you',

            isLoading: false,
            hasMore: true,
            nextCursor: null,
            loadMoreObserver: null,
            draw: 0,

            user: null,
            featuredPost: null,
            posts: [],

            isFeaturedPostDeleted: false,

            privacyFilter: null,
            privacyFilterOptions: [
                {
                    'value': '',
                    'display_as': 'All Posts',
                },
                {
                    'value': 'public',
                    'display_as': 'Public',
                },
                {
                    'value': 'pay_to_view',
                    'display_as': 'Pay to View',
                },
                {
                    'value': 'subscribers_only',
                    'display_as': 'Subscribers Only',
                },
            ],

        };
    },
    mounted: function() {

        // setup intersection observer
        this.loadMoreObserver = new IntersectionObserver((entries) => {
            const loadMoreElement = entries[0];
            if(loadMoreElement && loadMoreElement.isIntersecting){
                this.loadMore();
            }
        });

        // load more
        this.loadMore();

    },
    beforeDestroy(){

        // disconnect load more observer
        this.loadMoreObserver.disconnect();

    },
    methods: {
        changeTab: function(tab) {
            this.tab = tab;
            this.reload();
        },
        setupEndlessScrolling: function() {
            this.loadMoreObserver.disconnect();
            this.loadMoreObserver.observe(document.querySelector("#load-more"));
        },
        reload: function(shouldScrollToTop = true) {
            this.posts = [];
            this.isLoading = false;
            this.hasMore = true;
            this.nextCursor = null;
            this.draw = 0;
            if(shouldScrollToTop){
                this.scrollToTop();
            }
            this.loadMore();
        },
        scrollToTop() {
            window.scrollTo(0,0);
        },
        loadMore: function() {

            // do nothing if no more to load or if currently loading more
            if(!this.hasMore || this.isLoading){
                return;
            }

            this.isLoading = true;

            // increment draw
            var draw = ++this.draw;

            // make sure excluded post ids doesn't contain empty values
            const exlcludedPostIdsList = this.excludedPostIds?.split(",")?.filter(function(excludedPostId) {
                return excludedPostId != null && excludedPostId !== "";
            });

            // fetch posts
            axios.get(route('web-api.v1.feed.posts'), {
                params: {
                    feed_type: this.feedType ? this.feedType : this.tab,
                    user_id: this.userId,
                    hashtag: this.hashtag,
                    excluded_post_ids: exlcludedPostIdsList,
                    featured_post_id: this.featuredPostId !== "" ? this.featuredPostId : null,
                    privacy: this.privacyFilter !== "" ? this.privacyFilter : null,
                    cursor: this.nextCursor,
                },
            }).then((response) => {

                // do nothing if response is for previous draw
                if(this.draw !== draw){
                    return;
                }

                // get json data from response
                const json = response.data;

                // add all results to list
                this.user = json.user;
                this.featuredPost = json.featured_post;
                json.posts.data.forEach((post) => {
                    this.posts.push(post);
                });

                // check if we have more results
                if(json.posts.next_cursor){
                    this.hasMore = true;
                    this.nextCursor = json.posts.next_cursor;
                } else {
                    this.hasMore = false;
                }

                // setup endless scrolling if we have more entries
                if(this.hasMore){
                    this.setupEndlessScrolling();
                }

                // init read more for new posts after ui updates
                this.$nextTick(() => {
                    window.initReadMoreJs();
                });

            }).catch((err) => {

                // do nothing if response is for previous draw
                if(this.draw !== draw){
                    return;
                }

                // show error message
                window.toastr.error("Something went wrong. Please try again.", null, {
                    positionClass: 'toast-bottom-right',
                });

            }).then(() => {

                // do nothing if response is for previous draw
                if(this.draw !== draw){
                    return;
                }

                // no longer loading
                this.isLoading = false;

            });

        },
        onUserFollowed: function(userId) {
            // update following state of all posts by the provided user id
            this.posts.forEach((post) => {
                if(post.user.id === userId){
                    post.is_following = true;
                }
            });
        },
        onUserUnfollowed: function(userId) {
            // update following state of all posts by the provided user id
            this.posts.forEach((post) => {
                if(post.user.id === userId){
                    post.is_following = false;
                }
            });
        },
        onUserHidden: function(userId) {
            // remove all posts by hidden user
            this.posts = this.posts.filter((post) => post.user.id !== userId);
        },
        onPostHidden: function(postId) {
            // remove post from list
            this.posts = this.posts.filter((p) => p.id !== postId);
        },
        onPostDeleted: function(post) {
            // remove post from list
            this.posts = this.posts.filter((p) => p.id !== post.id);
        },
        onFeaturedPostDeleted: function() {
            this.isFeaturedPostDeleted = true;
        },
        onPrivacyFilterSelected: function(value) {
            this.privacyFilter = value;
            this.reload(false);
        },
        route: function(name) {
            return window.route(name);
        },
    },
}
</script>
